import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import './Login.css';
import { login } from '../../service/Auth.service';
import AuthContext from '../../context/Auth.context';
import { loginSchema } from '../../schemas/login/login.schema';
import coxLogo from '../../public/images/cox-logo.png';
import Input from '../../components/Input/Input';
import InputText from '../../components/Input/InputText';

const Login = () => {
  const [, setAuth] = useContext(AuthContext);
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
      rememberMe: false
    },
    validationSchema: loginSchema,
    validateOnChange: false,
    validateOnBlur: true,
    onSubmit: async ({ email, password, rememberMe }) => {
      try {
        await login(email, password, rememberMe);
        setAuth(true);

        navigate('/', { replace: true });
      } catch (error) {
        formik.setFieldError('password', error.message);
      }
    }
  });

  return (
    <div
      id="login-wrapper"
      className="flex min-h-screen flex-1 flex-col align-center justify-center px-6 py-12 lg:px-8"
    >
      <div className="sm:mx-auto sm:w-full sm:max-w-sm">
        <form
          className="space-y-6 shadow-md rounded px-8 pt-6 pb-8 mb-4 bg-white"
          onSubmit={formik.handleSubmit}
          noValidate
        >
          <div className="mt-2 mb-3 flex justify-center">
            <img src={coxLogo} alt="Cox Automotive Logo" />
          </div>

          <InputText
            label="E-mail"
            id="email"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.email}
            dataTest="login-form-email"
            error={formik.errors.email}
            required
          />

          <Input
            label="Password"
            type="password"
            id="password"
            placeholder="********"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.password}
            dataTest="login-form-password"
            error={formik.errors.password}
            required
          />

          <div className="mt-2 flex items-center remember-me-wrapper">
            <input
              name="rememberMe"
              id="rememberMe"
              className="border-2 border-grey-200 bg-white shadow-sm hover:border-grey-300  focus:border-purple-100 inline-block rounded-sm focus:outline-none focus:ring-0 focus:ring-inherit checked:hover:bg-purple-100 checked:focus:bg-purple-100 checked:bg-purple-100"
              value={formik.values.rememberMe}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              type="checkbox"
              data-testid="login-form-remember-me"
            />
            <label
              htmlFor="rememberMe"
              className="inline-block text-sm font-medium text-grey-400"
              data-testid="login-form-remember-me-label"
            >
              Remember me
            </label>
          </div>

          <button
            type="submit"
            name="submit"
            data-testid="login-form-submit"
            disabled={formik.isSubmitting}
            className="flex w-full justify-center shadow-sm rounded-sm bg-purple-100 px-2 py-4 text-white font-bold font-sans text-base focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
          >
            Sign in
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
